import { useEffect, useRef, useState } from "react";
import "./home.scss";
import homeImgSm from "../../assets/home_small.webp";

import gsap from "gsap";
const Home = () => {
  const [index, setIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const textRef = useRef(null);
  const menuRef = useRef(null);
  const sectionHeaderRef = useRef(null);
  const menuAnimControllerRef = useRef(null);
  const menuListRef = useRef(null);
  const TEXTS = [
    "FOOD & COSUMER PRODUCTS",
    "CONFORMITY ASSESSMENT",
    "TRAININGS",
    "SOURCING",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      // Animate out
      gsap.to(textRef.current, {
        y: -30,
        opacity: 0,
        duration: 0.4,
        ease: "power2.out",
        onComplete: () => {
          // Update text
          setIndex((prev) => (prev + 1) % TEXTS.length);
          // Animate in
          gsap.fromTo(
            textRef.current,
            { y: 30, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.6,
              ease: "elastic.out(1, 0.5)",
            }
          );
        },
      });
    }, 4000);

    return () => clearInterval(interval);
  }, [TEXTS.length]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      menuAnimControllerRef.current = gsap
        .timeline({ paused: true })
        .to(menuRef.current, {
          height: "100vh",
          margin: "0",
          maxWidth: "100vw",
          width: "100vw",
          borderRadius: "0",
          duration: "0.7",
        })
        .to(
          sectionHeaderRef.current,
          {
            opacity: 0,
          },
          "<"
        )
        .to(menuListRef.current, {
          display: "flex",
          duration: "1",
        });
    });
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    if (menuOpen) {
      menuAnimControllerRef.current.timeScale(1).play();
    } else {
      menuAnimControllerRef.current.timeScale(2).reverse();
    }
  }, [menuOpen]);

  return (
    <div className="home_main">
      <img src={homeImgSm} alt="highq background" />
      <div
        className="home_contents"
        data-aos="zoom-in"
        data-aos-duration="700"
        data-aos-delay="300"
        data-aos-offset="200"
        data-aos-easing="ease-in-out"
      >
        <div className="home_sections_words text_rotator">
          <h1 className="home_sections_words_inside">
            EMPOWERING YOUR BUSINESS WITH EXPERT CONSULTING IN{" "}
          </h1>
          <h1 className="service_category" ref={textRef}>
            {TEXTS[index]}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Home;
